<template>
  <div class="tickets">
    <ruth-header :tickets="false"></ruth-header>
    <div id="container" class="nobackgroundimg">
      <div id="content">
        <h1 class="ticketsheading">DVD</h1>
        <h2>Es freut uns, dass du die DVD zum Musical gekauft hast.</h2>
        <h3>Um die Download-Version zu öffnen, gib hier den Code ein:</h3>
        <div class="form">
          <form method="get" action="https://kisi.vhx.tv/checkout/ruth-musical/purchase">
            <div class="inputs">
              <input type="text" required name="code" placeholder="Code">
              <div class="ticket-button">
                  <input type="submit" value="Öffnen">
                  <span class="glyphicon glyphicon-menu-right"></span>
              </div>
            </div>
          </form>
        </div>
      </div>

      <social-media></social-media>
      <ruth-footer></ruth-footer>
      <ruth-overlay></ruth-overlay>
    </div>
  </div>
</template>

<script>
import ruthHeader from "./GlobalSegments/Header";
import socialMedia from "./GlobalSegments/SocialMedia";
import ruthFooter from "./GlobalSegments/Footer";

export default {
  name: 'Dvd',
  data: function () {
    return {};
  },
  components: {
    ruthHeader,
    socialMedia,
    ruthFooter,
  },
};
</script>

<style lang="scss">
@import "../assets/scss/var";
h3 {
  text-align: center;
}
.form {
    text-align: center;
    margin-top: 36px;

    .inputs {
      margin-top: 24px;
      display: flex;
      justify-content: center;
    }

    .ticket-button {
        margin-left: 12px;
        @include ticket_button;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dvd.vue